export const buildOpportunitiesModals = ({ uiState, actions, components, ctx }) => {
  const { onClose, onCloseError } = actions || {};
  const { 
    removedOpportunities = [], 
    opportunityTypes = {},
    errorStatus,
    errorDetails = [],
    errorPage,
    hasMoreThanOneItem = false,
    operationType,
    products = []
  } = ctx || {};
  const { isOpen = false, isErrorOpen = false } = uiState || {};
  const { ModalRemovedOpp, ErrorModal } = components;

  return {
    modalState: {
      removedOpp: isOpen,
      error: isErrorOpen,
    },
    components: {
      removedOpp: ModalRemovedOpp,
      error: ErrorModal,
    },
    propsMap: {
      removedOpp: {
        actions: { onClose: onClose },
        ctx: { removedOpportunities: removedOpportunities, opportunityTypes: opportunityTypes, products: products },
        uiState: { isOpen: isOpen },
      },
      error: {
        actions: { onClose: onCloseError },
        ctx: {
          page: errorPage,
          details: errorDetails,
          errorStatus: errorStatus,
          operationType: operationType
        },
        uiState: {
          isOpen: isErrorOpen,
          hasMoreThanOneItem: hasMoreThanOneItem,
        },
      },
    },
  };
}